export const normalizeEmailAddress = (value) => {
  const text = String(value || '').trim().toLowerCase();
  if (!text) return '';
  if (!text.includes('@')) return '';
  return text;
};

export const collectUniqueEmails = (rows, selectors) => {
  const list = Array.isArray(rows) ? rows : [];
  const keys = Array.isArray(selectors) ? selectors.filter((s) => typeof s === 'function') : [];
  const seen = new Set();

  list.forEach((row) => {
    keys.forEach((pick) => {
      const normalized = normalizeEmailAddress(pick(row));
      if (normalized) seen.add(normalized);
    });
  });

  return Array.from(seen);
};

export const toCommaDelimitedEmailText = (emails) => {
  return (Array.isArray(emails) ? emails : []).filter(Boolean).join(', ');
};

export const normalizeCommaDelimitedEmailText = (text) => {
  const emails = String(text || '')
    .split(',')
    .map((part) => normalizeEmailAddress(part))
    .filter(Boolean);
  return toCommaDelimitedEmailText(Array.from(new Set(emails)));
};
